  export function imageExists(url, callback) {
    var img = new Image();
    img.onload = function() { callback(true, url); };
    img.onerror = function() { callback(false, url); };
    img.src = url;
  }